






















































/**
 * Double-confirmation for the "Request Sales Order" action. Once confirmed the
 * quote is submitted to NetSuite and the order desk is notified, after which the
 * quote can no longer be edited in this app — the message makes that explicit.
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */

import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class ConfirmRequestSalesOrder extends Vue {
  @Prop({ default: "Request Sales Order" }) title!: string;
  @Prop({
    default:
      "This will submit the quote to NetSuite and notify the order desk to process it into a Sales Order. Once requested, the quote can no longer be edited in this app. Are you sure you want to continue?"
  })
  message!: string;
  @Prop({ default: "Request Sales Order" }) confirmLabel!: string;

  protected closeModal(): void {
    this.$emit("close");
  }
}
